module.exports = __webpack_public_path__ + "static/media/2048.43b0e77e.gif";